import { Toaster } from 'react-hot-toast'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
// import ActivityFeed from './components/ActivityFeed'  // Geçici kapatıldı - topbar'ı itiyor
import AiCloudLayout from './components/layout/AiCloudLayout'
import RunAIOSLayout from './components/layout/RunAIOSLayout'
import ErrorBoundary from './components/shared/ErrorBoundary'
import ProtectedRoute from './components/shared/ProtectedRoute'
import { AuthProvider } from './contexts/AuthContext'
import { WebSocketProvider } from './contexts/WebSocketContext'
import { ToastProvider } from './hooks/useToast'
// About, Help, Support, Terms, Privacy, FAQ → redirected to /ask-ai
import AgentSocialControl from './pages/admin/AgentSocialControl'
import ApiKeyTest from './pages/admin/ApiKeyTest'
import FlzHubControl from './pages/admin/FlzHubControl'
import AdminPanel from './pages/AdminPanel'
import AgentDetail from './pages/AgentDetail'
import AgentEdit from './pages/AgentEdit'
import Agents from './pages/Agents'
import AgentsListing from './pages/AgentsListing'
import AdminLLMConfig from './pages/admin/AdminLLMConfig'
import AiCloud from './pages/AiCloud'
import AddAgentPage from './pages/aicloud/agents/AddAgentPage'
import AgentsPage from './pages/aicloud/agents/AgentsPage'
import AiCloudHome from './pages/aicloud/AiCloudHome'
import AiCloudSettingsPage from './pages/aicloud/AiCloudSettingsPage'
import AWSSetup from './pages/aicloud/AWSSetup'
import AzureSetup from './pages/aicloud/AzureSetup'
import CLIDownloadPage from './pages/aicloud/CLIDownloadPage'
import CloudflareSetup from './pages/aicloud/CloudflareSetup'
import ExportData from './pages/aicloud/ExportData'
import FAQPage from './pages/aicloud/FAQPage'
import GCPSetup from './pages/aicloud/GCPSetup'
import OpenClawMCP from './pages/aicloud/OpenClawMCP'
import AlibabaPage from './pages/aicloud/platforms/AlibabaPage'
import ApiKeysPage from './pages/aicloud/platforms/ApiKeysPage'
import AWSPage from './pages/aicloud/platforms/AWSPage'
import AzurePage from './pages/aicloud/platforms/AzurePage'
import CloudflarePage from './pages/aicloud/platforms/CloudflarePage'
import DigitalOceanPage from './pages/aicloud/platforms/DigitalOceanPage'
import GCPPage from './pages/aicloud/platforms/GCPPage'
import GpuProvidersPage from './pages/aicloud/platforms/GpuProvidersPage'
import HuaweiPage from './pages/aicloud/platforms/HuaweiPage'
import IBMPage from './pages/aicloud/platforms/IBMPage'
import LocalLLMPage from './pages/aicloud/platforms/LocalLLMPage'
import PetalsPage from './pages/aicloud/platforms/PetalsPage'
import WebLLMPage from './pages/aicloud/platforms/WebLLMPage'
import ResearchProjectsPage from './pages/aicloud/projects/ResearchProjectsPage'
import WorkProjectsPage from './pages/aicloud/projects/WorkProjectsPage'
import RunAIChatPage from './pages/aicloud/RunAIChatPage'
import InstalledSkillsPage from './pages/aicloud/skills/InstalledSkillsPage'
import SkillDetailPage from './pages/aicloud/skills/SkillDetailPage'
import SkillsPage from './pages/aicloud/skills/SkillsPage'
import AiCloudSocialPage from './pages/aicloud/social/AiCloudSocialPage'
import WalletOSPage from './pages/aicloud/WalletOSPage'
import AiCloudSetup from './pages/AiCloudSetup'
import AskAI from './pages/AskAI'
import CloudIntegration from './pages/CloudIntegration'
import CreateAgent from './pages/CreateAgent'
import CreateProject from './pages/CreateProject'
import Discover from './pages/Discover'
import ElementList from './pages/ElementList'
import Esma from './pages/Esma'
import ExpertDetail from './pages/ExpertDetail'
import ExpertList from './pages/ExpertList'
// import FAQ from './pages/FAQ'
import FilizAI from './pages/FilizAI'
import FlzHubChat from './pages/FlzHubChat'
// import Help from './pages/Help'
import Home from './pages/Home'
import InvitationAccept from './pages/InvitationAccept'
import LandingPage from './pages/LandingPage'
import Leaderboard from './pages/Leaderboard'
import LLMConfig from './pages/LLMConfig'
import LLMOpenClawLocal from './pages/LLMOpenClawLocal'
import LLMRouter from './pages/LLMRouter'
import LLMSharedPool from './pages/LLMSharedPool'
import Login from './pages/Login'
import VerifyEmail from './pages/VerifyEmail'
import MyAgents from './pages/MyAgents'
import MyProjects from './pages/MyProjects'
import Notifications from './pages/Notifications'
import OSHomePage from './pages/os/OSHomePage'
import OSStatsPage from './pages/os/OSStatsPage'
import PetalsMining from './pages/PetalsMining'
import PostDetail from './pages/PostDetail'
// import Privacy from './pages/Privacy'
import Profile from './pages/Profile'
import ProjectDetail from './pages/ProjectDetail'
import Projects from './pages/Projects'
import ProjectsListing from './pages/ProjectsListing'
import ProjectWorkspace from './pages/ProjectWorkspace'
import Register from './pages/Register'
import Research from './pages/Research'
import Settings from './pages/Settings'
import SkillsMarketplace from './pages/SkillsMarketplace'
import SocialFeed from './pages/SocialFeed'
import SocialFollowing from './pages/SocialFollowing'
import SocialSaved from './pages/SocialSaved'
import StoreTest from './pages/StoreTest'
// import Support from './pages/Support'
import Tasks from './pages/Tasks'
// import Terms from './pages/Terms'
import ThemeDemo from './pages/ThemeDemo'
import Tokenomics from './pages/Tokenomics'
import AWSTutorial from './pages/tutorials/AWSTutorial'
import AzureTutorial from './pages/tutorials/AzureTutorial'
import CloudflareTutorial from './pages/tutorials/CloudflareTutorial'
import GCPTutorial from './pages/tutorials/GCPTutorial'
import GDriveTutorial from './pages/tutorials/GDriveTutorial'
import OneDriveTutorial from './pages/tutorials/OneDriveTutorial'
import UserProfile from './pages/UserProfile'
import Organization from './pages/Organization'
import Wallet from './pages/Wallet'
import Billing from './pages/Billing'
import UserSettingsOSPage from './pages/aicloud/UserSettingsOSPage'
import Work from './pages/Work'
import WorkCategories from './pages/WorkCategories'
import WorkCreate from './pages/WorkCreate'
import WorkDetail from './pages/WorkDetail'
import HabitatPage from './pages/HabitatPage'
import Onboarding from './pages/Onboarding'
import { AppProvider } from './store/useAppStore'

// Wrapper component for ErrorBoundary per route
const RouteWithErrorBoundary = ({ children }: { children: React.ReactNode }) => (
  <ErrorBoundary>{children}</ErrorBoundary>
)

export default function App() {
  return (
    <AuthProvider>
    <AppProvider>
    <WebSocketProvider>
    <ToastProvider>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      {/* <ActivityFeed /> */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'var(--card-bg)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border-color)',
            borderRadius: '12px',
            padding: '16px',
            fontSize: '14px',
            fontWeight: '500',
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<RouteWithErrorBoundary><LandingPage /></RouteWithErrorBoundary>} />
        <Route path="/home" element={<RouteWithErrorBoundary><Home /></RouteWithErrorBoundary>} />
        <Route path="/filizai" element={<RouteWithErrorBoundary><FilizAI /></RouteWithErrorBoundary>} />
        <Route path="/login" element={<RouteWithErrorBoundary><Login /></RouteWithErrorBoundary>} />
        <Route path="/register" element={<RouteWithErrorBoundary><Register /></RouteWithErrorBoundary>} />
        <Route path="/verify-email" element={<RouteWithErrorBoundary><VerifyEmail /></RouteWithErrorBoundary>} />
        <Route path="/help" element={<Navigate to="/ask-ai" replace />} />
        <Route path="/invitations/:token/accept" element={<RouteWithErrorBoundary><InvitationAccept /></RouteWithErrorBoundary>} />
        <Route path="/faq" element={<Navigate to="/ask-ai" replace />} />
        <Route path="/about" element={<Navigate to="/ask-ai" replace />} />
        <Route path="/support" element={<Navigate to="/ask-ai" replace />} />
        <Route path="/terms" element={<Navigate to="/ask-ai" replace />} />
        <Route path="/privacy" element={<Navigate to="/ask-ai" replace />} />
        <Route path="/tokenomics" element={<RouteWithErrorBoundary><Tokenomics /></RouteWithErrorBoundary>} />
        <Route path="/store-test" element={<RouteWithErrorBoundary><StoreTest /></RouteWithErrorBoundary>} />
        <Route path="/theme-demo" element={<RouteWithErrorBoundary><ThemeDemo /></RouteWithErrorBoundary>} />
        <Route path="/onboarding" element={<ProtectedRoute><RouteWithErrorBoundary><Onboarding /></RouteWithErrorBoundary></ProtectedRoute>} />

        {/* Public - Kesfet */}
        <Route path="/discover" element={<RouteWithErrorBoundary><Discover /></RouteWithErrorBoundary>} />
        <Route path="/projects" element={<RouteWithErrorBoundary><Projects /></RouteWithErrorBoundary>} />
        <Route path="/work" element={<RouteWithErrorBoundary><Work /></RouteWithErrorBoundary>} />
        <Route path="/work/create" element={<ProtectedRoute><RouteWithErrorBoundary><WorkCreate /></RouteWithErrorBoundary></ProtectedRoute>} />
        <Route path="/work/categories" element={<RouteWithErrorBoundary><WorkCategories /></RouteWithErrorBoundary>} />
        <Route path="/work/:taskId" element={<ProtectedRoute><RouteWithErrorBoundary><WorkDetail /></RouteWithErrorBoundary></ProtectedRoute>} />
        <Route path="/projects-listing" element={<RouteWithErrorBoundary><ProjectsListing /></RouteWithErrorBoundary>} />
        <Route path="/agents" element={<RouteWithErrorBoundary><Agents /></RouteWithErrorBoundary>} />
        <Route path="/agents-listing" element={<RouteWithErrorBoundary><AgentsListing /></RouteWithErrorBoundary>} />
        <Route path="/habitat/:agentId" element={<ProtectedRoute><RouteWithErrorBoundary><HabitatPage /></RouteWithErrorBoundary></ProtectedRoute>} />
        <Route path="/ask-ai" element={<RouteWithErrorBoundary><AskAI /></RouteWithErrorBoundary>} />
        <Route path="/social" element={<RouteWithErrorBoundary><SocialFeed /></RouteWithErrorBoundary>} />
        <Route path="/social/following" element={<RouteWithErrorBoundary><SocialFollowing /></RouteWithErrorBoundary>} />
        <Route path="/social/saved" element={<RouteWithErrorBoundary><SocialSaved /></RouteWithErrorBoundary>} />
        <Route path="/social/post/:id" element={<RouteWithErrorBoundary><PostDetail /></RouteWithErrorBoundary>} />
        <Route path="/flzhub" element={<Navigate to="/flzhub/chat" replace />} />
        <Route path="/flzhub/chat" element={<ProtectedRoute requireAdmin={true}><RouteWithErrorBoundary><FlzHubChat /></RouteWithErrorBoundary></ProtectedRoute>} />
        <Route path="/cloud" element={<RouteWithErrorBoundary><CloudIntegration /></RouteWithErrorBoundary>} />
        <Route path="/cloud/tutorial/cloudflare" element={<RouteWithErrorBoundary><CloudflareTutorial /></RouteWithErrorBoundary>} />
        <Route path="/cloud/tutorial/aws" element={<RouteWithErrorBoundary><AWSTutorial /></RouteWithErrorBoundary>} />
        <Route path="/cloud/tutorial/gcp" element={<RouteWithErrorBoundary><GCPTutorial /></RouteWithErrorBoundary>} />
        <Route path="/cloud/tutorial/azure" element={<RouteWithErrorBoundary><AzureTutorial /></RouteWithErrorBoundary>} />
        <Route path="/cloud/tutorial/gdrive" element={<RouteWithErrorBoundary><GDriveTutorial /></RouteWithErrorBoundary>} />
        <Route path="/cloud/tutorial/onedrive" element={<RouteWithErrorBoundary><OneDriveTutorial /></RouteWithErrorBoundary>} />
        <Route path="/petals-mining" element={<RouteWithErrorBoundary><PetalsMining /></RouteWithErrorBoundary>} />
        <Route path="/experts" element={<RouteWithErrorBoundary><ExpertList /></RouteWithErrorBoundary>} />
        <Route path="/esma" element={<RouteWithErrorBoundary><Esma /></RouteWithErrorBoundary>} />
        <Route path="/elements" element={<RouteWithErrorBoundary><ElementList /></RouteWithErrorBoundary>} />
        <Route path="/leaderboard" element={<RouteWithErrorBoundary><Leaderboard /></RouteWithErrorBoundary>} />
        <Route path="/tasks" element={<RouteWithErrorBoundary><Tasks /></RouteWithErrorBoundary>} />
        <Route path="/research" element={<RouteWithErrorBoundary><Research /></RouteWithErrorBoundary>} />
        {/* AiCloud public landing */}
        <Route path="/aicloud" element={<RouteWithErrorBoundary><AiCloud /></RouteWithErrorBoundary>} />
        <Route path="/aicloud/setup" element={<RouteWithErrorBoundary><AiCloudSetup /></RouteWithErrorBoundary>} />
        <Route path="/aicloud/setup/cloudflare" element={<RouteWithErrorBoundary><CloudflareSetup /></RouteWithErrorBoundary>} />
        <Route path="/aicloud/setup/azure" element={<RouteWithErrorBoundary><AzureSetup /></RouteWithErrorBoundary>} />
        <Route path="/aicloud/setup/gcp" element={<RouteWithErrorBoundary><GCPSetup /></RouteWithErrorBoundary>} />
        <Route path="/aicloud/setup/aws" element={<RouteWithErrorBoundary><AWSSetup /></RouteWithErrorBoundary>} />
        <Route path="/aicloud/mcp" element={<RouteWithErrorBoundary><OpenClawMCP /></RouteWithErrorBoundary>} />
        <Route path="/runcloud" element={<Navigate to="/aicloud" replace />} />

        {/* AiCloud Dashboard - sol sidebar layout (Cloudflare dashboard gibi) */}
        {/* /aicloud/app altinda - public landing ile cakisma yok */}
        <Route path="/aicloud/app" element={
          <ProtectedRoute>
            <RouteWithErrorBoundary><AiCloudLayout /></RouteWithErrorBoundary>
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<AiCloudHome />} />
          <Route path="platforms/api-keys" element={<ApiKeysPage />} />
          <Route path="platforms/local-llm" element={<LocalLLMPage />} />
          <Route path="platforms/gpu-providers" element={<GpuProvidersPage />} />
          <Route path="platforms/petals" element={<PetalsPage />} />
          <Route path="platforms/webllm" element={<WebLLMPage />} />
          <Route path="platforms/cloudflare" element={<CloudflarePage />} />
          <Route path="platforms/azure" element={<AzurePage />} />
          <Route path="platforms/aws" element={<AWSPage />} />
          <Route path="platforms/gcp" element={<GCPPage />} />
          <Route path="platforms/huawei" element={<HuaweiPage />} />
          <Route path="platforms/digitalocean" element={<DigitalOceanPage />} />
          <Route path="platforms/ibm" element={<IBMPage />} />
          <Route path="platforms/alibaba" element={<AlibabaPage />} />
          <Route path="agents" element={<AgentsPage />} />
          <Route path="agents/add" element={<AddAgentPage />} />
          <Route path="skills" element={<SkillsPage />} />
          <Route path="skills/installed" element={<InstalledSkillsPage />} />
          <Route path="skills/:id" element={<SkillDetailPage />} />
          <Route path="projects/work" element={<WorkProjectsPage />} />
          <Route path="projects/research" element={<ResearchProjectsPage />} />
          <Route path="social" element={<AiCloudSocialPage />} />
          <Route path="chat" element={<RunAIChatPage />} />
          <Route path="settings" element={<UserSettingsOSPage />} />
          <Route path="cli" element={<CLIDownloadPage />} />
          <Route path="faq" element={<FAQPage />} />
        </Route>

        {/* Public - Detay Sayfalari */}
        <Route path="/research/:id" element={<RouteWithErrorBoundary><ProjectDetail /></RouteWithErrorBoundary>} />
        <Route path="/work/:id" element={<RouteWithErrorBoundary><ProjectDetail /></RouteWithErrorBoundary>} />
        <Route path="/project/:projectId/workspace" element={<RouteWithErrorBoundary><ProjectWorkspace /></RouteWithErrorBoundary>} />
        <Route path="/agent/:id" element={<RouteWithErrorBoundary><AgentDetail /></RouteWithErrorBoundary>} />
        <Route path="/experts/:expertId" element={<RouteWithErrorBoundary><ExpertDetail /></RouteWithErrorBoundary>} />
        <Route path="/u/:username" element={<RouteWithErrorBoundary><Profile /></RouteWithErrorBoundary>} />
        <Route path="/profile/:username" element={<RouteWithErrorBoundary><UserProfile /></RouteWithErrorBoundary>} />
        <Route path="/user/:userId" element={<RouteWithErrorBoundary><UserProfile /></RouteWithErrorBoundary>} />

        {/* /dashboard → RunAI OS (yeni AI OS dashboard) */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <RouteWithErrorBoundary><RunAIOSLayout /></RouteWithErrorBoundary>
          </ProtectedRoute>
        }>
          <Route index element={<OSHomePage />} />
          <Route path="stats" element={<OSStatsPage />} />
          <Route path="agents" element={<AgentsPage />} />
          <Route path="agents/add" element={<AddAgentPage />} />
          <Route path="skills" element={<SkillsPage />} />
          <Route path="skills/installed" element={<InstalledSkillsPage />} />
          <Route path="skills/:id" element={<SkillDetailPage />} />
          <Route path="projects/work" element={<WorkProjectsPage />} />
          <Route path="projects/research" element={<ResearchProjectsPage />} />
          <Route path="social" element={<AiCloudSocialPage />} />
          <Route path="chat" element={<RunAIChatPage />} />
          <Route path="settings" element={<AiCloudSettingsPage />} />
          <Route path="cli" element={<CLIDownloadPage />} />
          <Route path="faq" element={<FAQPage />} />
          <Route path="wallet" element={<WalletOSPage />} />
          <Route path="billing" element={<Billing />} />
          <Route path="platforms/api-keys" element={<ApiKeysPage />} />
          <Route path="platforms/cloudflare" element={<CloudflarePage />} />
          <Route path="platforms/azure" element={<AzurePage />} />
          <Route path="platforms/aws" element={<AWSPage />} />
          <Route path="platforms/gcp" element={<GCPPage />} />
          <Route path="platforms/huawei" element={<HuaweiPage />} />
          <Route path="platforms/digitalocean" element={<DigitalOceanPage />} />
          <Route path="platforms/ibm" element={<IBMPage />} />
          <Route path="platforms/alibaba" element={<AlibabaPage />} />
          <Route path="platforms/local-llm" element={<LocalLLMPage />} />
          <Route path="platforms/petals" element={<PetalsPage />} />
          <Route path="platforms/webllm" element={<WebLLMPage />} />
          <Route path="platforms/gpu-providers" element={<GpuProvidersPage />} />
        </Route>
        <Route
          path="/user-panel"
          element={<Navigate to="/dashboard" replace />}
        />
        <Route
          path="/profile"
          element={<Navigate to="/dashboard/settings" replace />}
        />
        <Route
          path="/profile/"
          element={<Navigate to="/dashboard/settings" replace />}
        />
        <Route
          path="/my-projects"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <MyProjects />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/my-agents"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <MyAgents />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/create-project"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <CreateProject />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/projects/create"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <CreateProject />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/create-agent"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <CreateAgent />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/agents/create"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <CreateAgent />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/agents/:id/edit"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <AgentEdit />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/project/:id/edit"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <CreateProject />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/projects/:id/edit"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <CreateProject />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/wallet"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <Wallet />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/notifications"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <Notifications />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/settings"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/org"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <Organization />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/org/:orgId"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <Organization />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/llm-config"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <LLMConfig />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/llm-shared-pool"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <LLMSharedPool />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/llm-openclaw-local"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <LLMOpenClawLocal />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/llm-router"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <LLMRouter />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/skills-marketplace"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <SkillsMarketplace />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />

        <Route
          path="/aicloud/export"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute>
                <ExportData />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />

        {/* Admin routes - admin rolu gerekli */}
        <Route
          path="/admin"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute requireAdmin>
                <AdminPanel />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/admin/api-keys"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute requireAdmin>
                <ApiKeyTest />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/admin/flzhub"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute requireAdmin>
                <FlzHubControl />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/admin/agent-social"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute requireAdmin>
                <AgentSocialControl />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
        <Route
          path="/admin/llm-config"
          element={
            <RouteWithErrorBoundary>
              <ProtectedRoute requireAdmin>
                <AdminLLMConfig />
              </ProtectedRoute>
            </RouteWithErrorBoundary>
          }
        />
      </Routes>
    </BrowserRouter>
    </ToastProvider>
    </WebSocketProvider>
    </AppProvider>
    </AuthProvider>
  )
}
